import { t } from '@/utils/i18n'
import { useState, useRef } from 'react'
import styles from './index.module.less'
import { Dropdown, Tabs } from 'antd-mobile'
import SelectableTag from '@/components/SelectableTag'
import { QueryType } from '@/constant/order'

interface IProps {
  tagId: string
  onChange: (tagId: string) => void
}

function TopTabbar(props: IProps) {
  const { tagId = QueryType.ALL, onChange } = props
  const dropdownRef = useRef<any>(null)
  const tagList = [
    {
      tagId: QueryType.ALL,
      tagName: t('全部'),
    },
    {
      tagId: QueryType.TO_CONFIRM,
      tagName: t('待确认'),
    },
    {
      tagId: QueryType.PURCHASING,
      tagName: t('采购中'),
    },
    // {
    //   tagId: QueryType.TO_SHIPPING,
    //   tagName: t('待发货'),
    // },
    // {
    //   tagId: QueryType.FIRST_LEG_SHIPED,
    //   tagName: t('头程已发货'),
    // },
    // {
    //   tagId: QueryType.AT_TRANSIT_WAREHOUSE,
    //   tagName: t('已到中转仓'),
    // },
    {
      tagId: QueryType.OVERSEA_SHIPPING,
      tagName: t('跨境运输中'),
    },
    {
      tagId: QueryType.WAREHOUSE_SORTING,
      tagName: t('仓库分拣中'),
    },
    {
      tagId: QueryType.TO_DELIVERY,
      tagName: t('待配送'),
    },
    {
      tagId: QueryType.TO_PICKUP,
      tagName: t('待自提'),
    },
    {
      tagId: QueryType.DELIVERYING,
      tagName: t('配送中'),
    },
    {
      tagId: QueryType.RETURNS,
      tagName: t('退换单'),
    },
    {
      tagId: QueryType.COMPLETED,
      tagName: t('已完成'),
    },
    {
      tagId: QueryType.CANCELED,
      tagName: t('已作废'),
    },
  ]

  const [activeKey, setActiveKey] = useState<string>(tagId)

  function onTagChange(value: string) {
    setActiveKey(value)
    onChange(value)
    dropdownRef.current?.close()
  }

  return (
    <div className={styles['top-tabbar']}>
      <div className={styles['scroll-bar']}>
        <Tabs activeKey={activeKey} onChange={onTagChange}>
          {!!tagList.length &&
            tagList.map((tag) => (
              <Tabs.Tab
                key={tag.tagId}
                title={tag.tagName}
                className={styles['tab-item']}
              />
            ))}
        </Tabs>
      </div>
      <Dropdown closeOnClickAway ref={dropdownRef}>
        <Dropdown.Item key="sorter" title={null}>
          <div className={styles['tag-list']}>
            {!!tagList.length &&
              tagList.map((tag) => (
                <SelectableTag
                  key={tag.tagId}
                  checked={activeKey === tag.tagId}
                  round
                  size="middle"
                  className={styles['tag-list-item']}
                  onClick={() => onTagChange(tag.tagId)}
                >
                  {tag.tagName}
                </SelectableTag>
              ))}
          </div>
        </Dropdown.Item>
      </Dropdown>
    </div>
  )
}

export default TopTabbar
